import React, { useEffect, useLayoutEffect } from "react";
import { useAuthStore } from "../../store";
import AuthPageShell from "../../components/forms/AuthPageShell";
import AuthSuccessScene from "../../components/forms/AuthSuccessScene";

import mixpanelService from "../../services/mixpanel";
import { useValidSSO } from "../../hooks/useValidSSO";

const SignUpSuccess = () => {
  useValidSSO()
  const userData = useAuthStore((s) => s.userData);

  useLayoutEffect(() => {
    const hasUserData = Object.keys(userData).length > 0;

    if (!hasUserData) return;

    mixpanelService.people.set_once("First Sign-In", {userData});
  }, [userData]);

  useEffect(() => {
    window.localStorage.clear();
  });

  return (
    <AuthPageShell variant="success">
      <AuthSuccessScene
        title="You're set"
        subtitle="Account created. Taking you to Tripplo…"
        area="sign-up-success"
      />
    </AuthPageShell>
  );
}

export default SignUpSuccess;
